import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();

  // Scroll must be force-triggered every time pathname changes
  // rome-ignore lint(nursery/useExhaustiveDependencies):
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
